<template>
  <div class="add-panel-users">
    <div class="add-panel-users__entrances">
      <label>Жителям каких подъездов доступна панель</label>
      <Select
        placeholder="Выберите подъезды"
        mode="tags"
        clearable
        :disabled="panelUsersData.available_to_all_residents"
        v-model="panelUsersData.selectedSections"
        :options="availableSections"
      />
    </div>

    <Checkbox
      v-model="panelUsersData.available_to_all_residents"
      label="Доступно всем жителям"
    />
  </div>
</template>

<script>
import Select from '../../Form/Select.vue'
import Checkbox from '../../Form/Checkbox.vue'

export default {
  name: 'AddPanelUsers',
  components: {
    Select,
    Checkbox,
  },
  data() {
    return {
      panelUsersData: {
        selectedSections: [],
        available_to_all_residents: false,
      },
      savedSelectedSections: [], // Для сохранения выбранных секций
    }
  },
  computed: {
    availableSections() {
      return this.$store.getters.availableSectionsOptions
    },
  },
  methods: {
    handleAvailableToAllResidentsChange(newValue) {
      if (newValue) {
        // Сохраняем текущий выбор перед очисткой
        if (this.panelUsersData.selectedSections.length > 0) {
          this.savedSelectedSections = this.panelUsersData.selectedSections
          this.panelUsersData.selectedSections = []
        }
      } else if (this.savedSelectedSections.length > 0) {
        // Восстанавливаем ранее сохраненные секции
        this.panelUsersData.selectedSections = this.savedSelectedSections
      }
    },
  },
  watch: {
    panelUsersData: {
      handler(newVal) {
        this.$store.dispatch('setPanelData', {
          key: 'users',
          value: newVal,
        })
      },
      deep: true,
    },
    'panelUsersData.available_to_all_residents': {
      handler(newValue) {
        this.handleAvailableToAllResidentsChange(newValue)
      },
      immediate: false,
    },
  },
  mounted() {
    const storedData = this.$store.getters.panelData.users
    if (storedData) {
      this.panelUsersData = { ...this.panelUsersData, ...storedData }
      if (storedData.selectedSections?.length > 0) {
        this.savedSelectedSections = storedData.selectedSections
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.add-panel-users {
  display: flex;
  flex-direction: column;
  gap: 24px;

  &__entrances {
    display: flex;
    flex-direction: column;
    gap: 8px;

    label {
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      color: $color-grey-3;
    }
  }

  :deep(.multiselect) {
    min-height: 48px !important;
    border-radius: $border-radius-xs !important;
  }

  :deep(.multiselect-wrapper) {
    min-height: 48px !important;
    border-radius: $border-radius-xs !important;
    padding: 0 !important;
  }

  :deep(.multiselect-placeholder) {
    color: $input-placeholder-color !important;
  }

  :deep(.multiselect-tag) {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 34px;
    padding-top: 6px;
    padding-right: 8px;
    padding-bottom: 6px;
    padding-left: 8px;
    gap: 8px;
    border-radius: 4px;
    background-color: #f2f4f6 !important;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: -1%;
    color: $color-default;
  }
}
</style>
